import { useEffect } from "react";
import { getMenuAuth } from "src/apis/authApi";
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import useMenuStore from "src/store/useMenuStore";
import { safeApiCall } from "src/utils/safeApiResponse";

export default function useFetchActionbarAuth(forcedMenuCd?: string) {
  const setAuth = useActionbarAuthStore((state) => state.setAuth);
  const auth = useActionbarAuthStore((state) => state.auth);
  const { selectedThirdMenu } = useMenuStore();
  const menuCd = forcedMenuCd || selectedThirdMenu?.menuCd;
//   console.log("auth", auth);
//   console.log("menuCd", menuCd);

  useEffect(() => {
    if (!menuCd) return;
    
    safeApiCall(() => getMenuAuth(menuCd), {})
      .then((result) => {
        setAuth(result.data || {});
      });
  }, [menuCd, setAuth]);
}
